// @flow
import common from 'modules/Common/lang/en'
import landing from 'modules/Authenticate/lang/en'
import admin from 'modules/Admin/lang/en'

export default {
  common,
  landing,
  admin
}
